import { render, staticRenderFns } from "./ConfigList.vue?vue&type=template&id=2348658d&scoped=true&"
import script from "./ConfigList.vue?vue&type=script&lang=js&"
export * from "./ConfigList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigList.vue?vue&type=style&index=0&id=2348658d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2348658d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2348658d')) {
      api.createRecord('2348658d', component.options)
    } else {
      api.reload('2348658d', component.options)
    }
    module.hot.accept("./ConfigList.vue?vue&type=template&id=2348658d&scoped=true&", function () {
      api.rerender('2348658d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Config/ConfigList.vue"
export default component.exports